import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography,
  Divider,
  DatePicker,
  theme,
} from "antd";
import { Content } from "antd/es/layout/layout";
import Heading from "../../../../../components/common/heading";
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useContext,
} from "react";
import { routes } from "../../../../../routes";
const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const VoiceOfCustomer = (props) => {
  const { token } = useToken();
  const [form] = Form.useForm();
  const {
    dropDownproductRequirement,
    dropDowncustomerSupport,
    dropDowncustomerExpact,
    dropDownbusinessRequire,
    dropDownotherProductExpect,
    dropDownotherSupportExpect,
    dropDownotherBusinessExpect,
    handleOnChangeVOC,
  } = props;

  return (
    <Content style={{ paddingTop: 15 }}>
      <Row gutter={[8, 16]} className="card">
        <Col span={24}>
          <Heading
            text={"Voice of Customer เสียงของลูกค้า (VOC)"}
            size={4}
            style={{ margin: 0, color: token.thPrimary }}
          />
          <Divider />
        </Col>
        <Col span={24}>
          <Text strong>(VOC) ความต้องการต่อผลิตภัณฑ์/การบริการ ของ กนอ.</Text>
        </Col>
        <Col span={16}>
          <Form.Item
            label="1. ลูกค้ามีความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"productRequirement"}
            style={{ paddingBottom: 24 }}
          >
            <Select
              mode={"multiple"}
              allowClear
              showSearch={false}
              className="w-full"
              placeholder="กรุณาเลือก"
              optionFilterProp="children"
              onChange={(value, type) =>
                handleOnChangeVOC(value, "productRequirement")
              }
              hasfeedback="true"
            >
              {dropDownproductRequirement.map((option, i) => {
                return (
                  <Option key={i} value={option.vocUniqueId}>
                    {option.vocDetailTh}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="2. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"customerSupport"}
            style={{ paddingBottom: 24 }}
          >
            <Select
              mode={"multiple"}
              allowClear
              showSearch={false}
              className="w-full"
              placeholder="กรุณาเลือก"
              optionFilterProp="children"
              onChange={(value, type) =>
                handleOnChangeVOC(value, "customerSupport")
              }
              hasfeedback="true"
            >
              {dropDowncustomerSupport.map((option, i) => {
                return (
                  <Option key={i} value={option.vocUniqueId}>
                    {option.vocDetailTh}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="3. ลูกค้ามีความต้องการ ด้านการทำธุรกรรม (อนุมัติอนุญาตสิทธิประโยชน์) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"businessRequire"}
            style={{ paddingBottom: 24 }}
          >
            <Select
              mode={"multiple"}
              allowClear
              showSearch={false}
              className="w-full"
              placeholder="กรุณาเลือก"
              optionFilterProp="children"
              onChange={(value, type) =>
                handleOnChangeVOC(value, "businessRequire")
              }
              hasfeedback="true"
            >
              {dropDownbusinessRequire.map((option, i) => {
                return (
                  <Option key={i} value={option.vocUniqueId}>
                    {option.vocDetailTh}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="4. ลูกค้ามีความต้องการ/คาดหวัง ด้านการจัดการความสัมพันธ์(CRM) ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"customerExpact"}
            style={{ paddingBottom: 24 }}
          >
            <Select
              mode={"multiple"}
              allowClear
              showSearch={false}
              className="w-full"
              placeholder="กรุณาเลือก"
              optionFilterProp="children"
              onChange={(value, type) =>
                handleOnChangeVOC(value, "customerExpact")
              }
              hasfeedback="true"
            >
              {dropDowncustomerExpact.map((option, i) => {
                return (
                  <Option key={i} value={option.vocUniqueId}>
                    {option.vocDetailTh}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        <Divider strong={"true"} dashed />
        <Col span={16}>
          <Col span={24}>
            <Text strong>
              (VOC) ความคาดหวัง นอกเหนือจากผลิตภัณฑ์/บริการของ กนอ.
            </Text>
          </Col>

          <Form.Item
            label="1. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"otherProductExpect"}
            style={{ paddingBottom: 24 }}
          >
            <Select
              mode={"multiple"}
              allowClear
              showSearch={false}
              className="w-full"
              placeholder="กรุณาเลือก"
              optionFilterProp="children"
              onChange={(value, type) =>
                handleOnChangeVOC(value, "otherProductExpect")
              }
              hasfeedback="true"
            >
              {dropDownotherProductExpect.map((option, i) => {
                return (
                  <Option key={i} value={option.vocUniqueId}>
                    {option.vocDetailTh}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="2. ลูกค้ามีความคาดหวังที่นอกเหนือจากความต้องการ ด้านผลิตภัณฑ์และบริการ ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"otherSupportExpect"}
            style={{ paddingBottom: 24 }}
          >
            <Select
              mode={"multiple"}
              allowClear
              showSearch={false}
              className="w-full"
              placeholder="กรุณาเลือก"
              optionFilterProp="children"
              onChange={(value, type) =>
                handleOnChangeVOC(value, "otherSupportExpect")
              }
              hasfeedback="true"
            >
              {dropDownotherSupportExpect.map((option, i) => {
                return (
                  <Option key={i} value={option.vocUniqueId}>
                    {option.vocDetailTh}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="3.ลูกค้ามีความ คาดหวังที่นอกเหนือจากความต้องการ ด้านสนับสนุนลูกค้า ของ กนอ. อย่างไร (ตอบได้มากกว่า 1 ข้อ)"
            name={"otherBusinessExpect"}
            style={{ paddingBottom: 24 }}
          >
            <Select
              mode={"multiple"}
              allowClear
              showSearch={false}
              className="w-full"
              placeholder="กรุณาเลือก"
              optionFilterProp="children"
              onChange={(value, type) =>
                handleOnChangeVOC(value, "otherBusinessExpect")
              }
              hasfeedback="true"
            >
              {dropDownotherBusinessExpect.map((option, i) => {
                return (
                  <Option key={i} value={option.vocUniqueId}>
                    {option.vocDetailTh}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item
            label="4. Other VOC"
            name={"otherExpect"}
            style={{ paddingBottom: 24 }}
          >
            <Input.TextArea
              placeholder="รายละเอียด"
              onChange={(value, type) =>
                handleOnChangeVOC([value.target.value], "otherExpect")
              }
             />
          </Form.Item>
        </Col>
      </Row>
    </Content>
  );
};

export default VoiceOfCustomer;
